import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { genericHeaders, serviceUrl } from "../utils/apiConfig";
import axios from "axios";

const PayrollMetaData = () => {
  const [data, setData] = useState([]);
  const payrollMetaData = async () => {
    try {
      const url = `${serviceUrl}/api/lookup/payroll/getAll`;
      let response = await axios.get(url, { headers: genericHeaders() });
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    payrollMetaData();
  }, []);

  const earningsRows = Array.isArray(data?.earnings)
    ? data.earnings.map((item, index) => ({
        id: `earning-${index}`,
        name: item.name || "",
        type: "Earning",
        isActive: item.isActive || false,
        isCalculationNeeded: item.isCalcuationNeeded || false,
        percentageOfShare: item.perecentageofShare || 0,
        maxCappedAmount: item.maxCappedAmount || 0,
      }))
    : [];

  const deductionsRows = Array.isArray(data?.deductions)
    ? data.deductions.map((item, index) => ({
        id: `deduction-${index}`,
        name: item.name || "",
        type: "Deduction",
        isActive: item.isActive || false,
        isCalcuationNeeded: item.isCalcuationNeeded || false,
        percentageOfShare: item.perecentageofShare || 0,
        maxCappedAmount: item.maxCappedAmount || 0,
      }))
    : [];

  const allRows = [...earningsRows, ...deductionsRows];

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => (
        <div className="font-semibold text-gray-800 py-2 text-sm">{params.value}</div>
      ),
    },
    {
      field: "type",
      headerName: "Type",
      width: 120,
      renderCell: (params) => (
        <span
          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
            params.value === "Earning"
              ? "bg-green-100 text-green-800 border border-green-200"
              : "bg-red-100 text-red-800 border border-red-200"
          }`}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "percentageOfShare",
      headerName: "Percentage (%)",
      width: 100,
      type: "number",
      renderCell: (params) => (
        <div className="text-center font-semibold text-gray-700">
          {params.value > 0 ? `${params.value}%` : "-"}
        </div>
      ),
    },
    {
      field: "maxCappedAmount",
      headerName: "Max Capped Amount",
      width: 160,
      type: "number",
      renderCell: (params) => (
        <div className="text-center font-semibold text-gray-700">
          {params.value > 0 ? `₹${params.value.toLocaleString("en-IN")}` : "-"}
        </div>
      ),
    },
  ];

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="p-6">
      <div className="w- mx-auto">
        <div className="mb-8 text-center">
          <p className="text-sm text-gray-500 bg-white/70 inline-block px-4 py-2 rounded-full border border-gray-200">
            Last Revised On: {formatDate(data?.updatedDate)}
          </p>
        </div>

        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl border border-white/50 p-6">
          <div
            style={{ height: "100%", width: "100%" }}
            className="rounded-xl overflow-hidden"
          >
            <DataGrid
              rows={allRows}
              columns={columns}
              pagination={false}
              rowsPerPageOptions={[]}
              pageSizeOptions={[]}
              disableColumnFilter
              disableColumnSorting
              disableRowSelectionOnClick
              disableColumnMenu
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollMetaData;
